import { createFileRoute, redirect } from "@tanstack/react-router";

// The HSE page moved to /hse-ledelse. Permanently redirect the old slug.
export const Route = createFileRoute("/sikkerhedsledelse-hse")({
  beforeLoad: () => {
    throw redirect({ to: "/hse-ledelse", statusCode: 301 });
  },
});
